module.exports = require("./../_gen/openfl/Lib");